<template>
    <form @submit.prevent="submit">
        <slot :fields="fields"
              :message="message"
              :success="success"
              :is-loading="isLoading"
              :submit="submit"
              :reset="reset"
        />
    </form>
</template>

<script>
import {submitYiiForm} from "../../helpers/yii";

export default {
    name: "NewsletterForm",

    data() {
        return {
            fields: {
                email: null,
            },
            success: false,
            isLoading: false,
            message: null,
        };
    },

    inject: ['newsletterSubscribeUrl'],

    methods: {
        async submit() {
            this.isLoading = true;

            try {
                const response = await submitYiiForm(this.newsletterSubscribeUrl, this.fields);
                this.success = response.data.success;
                this.message = response.data.data.message;
                if (response.data.success) {
                    this.fields.email = null;
                }
            } finally {
                this.isLoading = false;
            }
        },

        reset() {
            this.fields.email = null;
            this.message = null;
        },
    },
}
</script>
